<template>
  <div class="platform-permissions">
    <BaseContainer
      :active-spacer="true"
      :permission-list="['master']"
    >
      <template v-slot:header-title>
        Gestão de usuários
      </template>
      <template v-slot:header-title-description>
        Cadastre usuários e gerencie suas permissões.
      </template>
      <BaseAlert>
        <b>Atenção:</b> O usuário criado será vinculado a todas as organizações matrizes e filiais que você possui em sua conta.
      </BaseAlert>
      <template v-slot:header-actions>
        <v-dialog
          :value="isModalActive"
          persistent
          transition="slide-y-reverse-transition"
          content-class="v-dialog--fullscreen"
          @input="updateModalActive"
        >
          <template v-slot:activator="{ on }">
            <BaseButton
              color="primary"
              v-on="on"
            >
              Adicionar usuário
            </BaseButton>
          </template>

          <BaseModal
            style="height: 100vh; flex-wrap: nowrap"
            :middle-image="modalInfo.middleImage"
            :show-indeterminate-progress="modalInfo.showIndeterminateProgress"
            :top-slot-content-title="modalInfo.topSlotContentTitle"
            :remove-button-close="modalInfo.removeButtonClose"
            :middle-slot-content-text-highlight="modalInfo.middleSlotContentTextHighlight"
            :middle-slot-content-text="modalInfo.middleSlotContentText"
            :middle-check-agree="modalInfo.middleCheckAgree"
            :bottom-buttons-align="modalInfo.bottomButtonsAlign"
            :bottom-slot-content-button-cancel-label="modalInfo.bottomSlotContentButtonCancelLabel"
            :bottom-slot-content-button-confirm-label="modalInfo.bottomSlotContentButtonConfirmLabel"
            :remove-button-cancel="modalInfo.removeButtonCancel"
            :remove-button-confirm="modalInfo.removeButtonConfirm"
            :modal-full-screen="true"
            body-background-color="var(--v-grayf8-base)"
            @on-cancel="cancelUserForm"
            @on-confirm="() => null"
          >
            <div style="margin: 0 auto">
              <v-form
                ref="formCreateOrEditUser"
                v-model="valid"
              >
                <v-container>
                  <BaseAlert>
                    <b>Atenção:</b> O usuário criado será vinculado a todas as organizações matrizes e filiais que você possui em sua conta.
                  </BaseAlert>
                  <v-row dense>
                    <h2 class="mt-6">
                      Dados pessoais
                    </h2>
                    <v-spacer />
                    <v-switch
                      id="qa-id-name-attributes-enabled"
                      v-model="user.attributes.enabled"
                      class="platform-organization-profile-account--switch mt-6"
                      color="primary"
                      :label="user.attributes.enabled ? 'Ativado' : 'Desativado'"
                    />
                  </v-row>

                  <v-divider class="my-4" />

                  <v-row dense>
                    <v-col sm="4">
                      <BaseInput
                        ref="userName"
                        v-model="user.name"
                        qa-identification-name="qa-id-name-user-name"
                        label="Nome*"
                      />
                    </v-col>

                    <v-col sm="4">
                      <BaseInput
                        ref="userName"
                        v-model="user.last_name"
                        qa-identification-name="qa-id-name-last-name"
                        label="Sobrenome*"
                      />
                    </v-col>
                  </v-row>
                  <v-row dense>
                    <v-col sm="4">
                      <EmailInput
                        ref="email"
                        v-model="user.email"
                        qa-identification-name="qa-id-name-email"
                        label="E-mail*"
                      />
                    </v-col>
                  </v-row>

                  <h2 class="mt-12">
                    Informações do usuário
                  </h2>
                  <p
                    class="pt-2"
                  >
                    Adicione informações ao usuário criando novos campos abaixo.
                  </p>
                  <v-divider class="my-4" />
                  <v-row dense>
                    <v-col sm="4">
                      <BaseInput
                        ref="nameAttribute"
                        v-model="attributeObject.name"
                        qa-identification-name="qa-id-name-user-attribute-name"
                        :rules="[isValidName]"
                        label="Título"
                      />
                    </v-col>

                    <v-col sm="4">
                      <BaseInput
                        ref="valueAttribute"
                        v-model="attributeObject.value"
                        qa-identification-name="qa-id-name-user-attribute-value"
                        label="Valor"
                      />
                    </v-col>
                    <v-col
                      sm="1"
                      class="text-right app-align-items-center"
                    >
                      <BaseButton
                        type="text"
                        class="app-button__link-text app-button--hide-ripple app-button--no-hover px-0"
                        qa-identification-name="qa-id-name-user-btn-add-attribute"
                        :is-disabled="addDisabled"
                        @click="addAttribute(attributeObject)"
                      >
                        {{ isEditingAttribute ? 'Atualizar' : 'Adicionar' }}
                      </BaseButton>
                      <BaseButton
                        v-if="isEditingAttribute"
                        type="text"
                        class="app-button__link-text app-button--hide-ripple app-button--no-hover px-2"
                        @click="cancelEditAttribute"
                      >
                        Cancelar
                      </BaseButton>
                    </v-col>
                  </v-row>

                  <v-row
                    dense
                    class="mb-12"
                  >
                    <v-col
                      cols="auto"
                      sm="9"
                      class="pl-0"
                    >
                      <template>
                        <BaseDataTable
                          v-if="visibleAttributes.length"
                          :headers="headersAttr"
                          :items="visibleAttributes"
                          :hide-actions="true"
                          background-color="transparent"
                          class="pb-4"
                        >
                          <template v-slot:inject-items="{ items }">
                            <tr
                              :key="items.item.name"
                            >
                              <td>
                                {{ items.item.name }}
                              </td>
                              <td>
                                {{ items.item.value }}
                              </td>
                              <td
                                class="text-right app-align-items-center"
                                style="justify-content: flex-end; min-width: 130px;"
                              >
                                <BaseButton
                                  type="text"
                                  class="app-button__link-text app-button--hide-ripple app-button--no-hover pa-0"
                                  @click="editAttribute(items.index)"
                                >
                                  Editar
                                </BaseButton>
                                <BaseButton
                                  type="text"
                                  class="app-button__link-text app-button--hide-ripple app-button--no-hover pa-0"
                                  @click="removeAttribute(items.index)"
                                >
                                  Apagar
                                </BaseButton>
                              </td>
                            </tr>
                          </template>
                        </BaseDataTable>
                      </template>
                    </v-col>
                  </v-row>

                  <h2 class="mt-6">
                    Tipo de acesso e permissões
                  </h2>
                  <v-divider class="my-4" />

                  <v-row>
                    <v-col
                      v-for="card, index in cardItems"
                      :key="index"
                      cols="12"
                      sm="6"
                      md="4"
                      lg="3"
                      class="pl-0 pr-6"
                    >
                      <v-hover
                        v-slot="{ hover }"
                      >
                        <BaseCardSimple
                          :card-image="card.image"
                          :card-title="card.title"
                          :card-text="card.text"
                          card-height="288"
                          :card-class="card.value === user.attributes.group ? 'selected' : hover ? 'hover' : ''"
                        >
                          <template v-slot:card-action>
                            <v-checkbox
                              v-model="user.attributes.group"
                              :name="`qa-id-name-attributes-group-${card.value}`"
                              :multiple="false"
                              label="Selecionar"
                              :value="card.value"
                            />
                          </template>
                        </BaseCardSimple>
                      </v-hover>
                    </v-col>
                  </v-row>

                  <v-row
                    dense
                    justify="end"
                  >
                    <v-col cols="auto">
                      <BaseButton
                        qa-identification-name="qa-id-name-button-cancel"
                        color="primary"
                        type="text"
                        @click="cancelUserForm"
                      >
                        Cancelar
                      </BaseButton>
                      <BaseButton
                        qa-identification-name="qa-id-name-button-confirm"
                        type="depressed"
                        color="primary"
                        :is-disabled="!valid || !user.attributes.group || loadPage || attributeObject.name !== '' || attributeObject.value !== ''"
                        @click="submitUserForm()"
                      >
                        {{ isEditingUser ? 'Salvar' : 'Cadastrar' }}
                      </BaseButton>
                    </v-col>
                  </v-row>
                </v-container>
              </v-form>
            </div>
          </BaseModal>
        </v-dialog>
      </template>
      <BaseDataTable
        :items="authzUserList"
        :headers="headers"
        :hide-actions="true"
        :options="{sortBy:['name']}"
        background-color="transparent"
      >
        <template v-slot:inject-items="scopedItems">
          <tr
            v-for="value in scopedItems"
            :key="value.index"
          >
            <td style="width: 80%">
              <div class="app-align-items-center">
                <v-icon class="mr-2">
                  account_circle
                </v-icon>
                {{ value.item.name }} {{ value.item.last_name }}
              </div>
            </td>
            <td style="min-width: 82px">
              {{ translateUserGroup(value.item.attributes.group) }}
            </td>
            <td style="min-width: 150px">
              {{ getUserStatus(value.item.attributes) }}
            </td>
            <td
              v-for="header in headersAttributes"
              :key="header.value"
              style="min-width: 150px;"
            >
              {{ value.item.attributes[header.value] || "-" }}
            </td>
            <td
              style="min-width:60px"
              class="text-right"
            >
              <BaseButton
                :qa-identification-name="`qa-id-name-button-edit-${value.index}`"
                type="text"
                color="blueff"
                class="app-button__link-text app-button--hide-ripple app-button--no-hover px-0"
                @click="editUser(value.item)"
              >
                Editar
              </BaseButton>
            </td>
          </tr>
        </template>
      </BaseDataTable>

      <BaseSnackbar
        :active-snackbar="feedback"
        :text-snackbar="feedbackMessage"
        :type-snackbar="feedbackColor"
        @closeSnackbar="feedback = !feedback"
      />
    </BaseContainer>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import permissions from '../../mixins/permissions'
import BaseDataTable from '../BaseDataTable'
import BaseModal from '../BaseModal'
import EmailInput from '../Input/EmailInput'
import BaseCardSimple from '../BaseCardSimple'
import BaseSnackbar from "../BaseSnackbar"
import BaseSnackbarConfiguration from "../../mixins/BaseSnackbarConfiguration"
import loader from '../../global/loader'
import BaseAlert from '../BaseAlert'

export default {
  components: { BaseDataTable, BaseModal, EmailInput, BaseCardSimple, BaseSnackbar, BaseAlert },
  mixins: [ permissions, BaseSnackbarConfiguration ],
  data() {
    return {
      headersDefault: [
        { text: "Usuário", value: "name" },
        { text: "Tipo de acesso", value: "attributes.group", width: 150 },
        { text: "Status", value: "attributes.enabled" }
      ],
      headers: [],
      headersAttr: [
        { text: "Título", value: "title" },
        { text: "Valor", value: "value", width: 150 },
        { text: "", value: "actions" }
      ],
      isModalActive: false,
      valid: false,
      modalInfo: {
        showIndeterminateProgress: false,
        topSlotContentTitle: "Cadastrar usuário",
        removeButtonClose: false,
        middleSlotContentTextHighlight: "",
        middleSlotContentText: "",
        bottomButtonsAlign: "right",
        bottomSlotContentButtonCancelLabel: "Cancelar",
        bottomSlotContentButtonConfirmLabel: "Cadastrar",
        removeButtonCancel: true,
        removeButtonConfirm: true,
        onCancel: null,
        onConfirm: null,
      },
      user: {
        name: "",
        last_name: "",
        email: "",
        attributes: {
          group: "",
          enabled: true
        }
      },
      attributeObject: {
        name: "",
        value: ""
      },
      attributeList: [],
      isEditingAttribute: false,
      attributeIndex: null,
      cardItems: [
        {
          image: "person-icon.png",
          title: "Master",
          text: "Pode criar, editar e desativar usuários; realizar operações na plataforma, além de consultas e extração de relatórios no programa.",
          value: "master"
        },
        {
          image: "person-icon.png",
          title: "Operador",
          text: "Pode realizar operações na plataforma, além de consultas e extração de relatórios no programa.",
          value: "operator"
        },
        {
          image: "person-icon.png",
          title: "Consultante",
          text: "Pode realizar consultas e extrair relatórios no programa.",
          value: "consultant"
        }
      ],
      isEditingUser: null
    }
  },
  computed: {
    ...mapState({
      authzUserList: (state) => state.programAuthz.authzUserList,
      loadPage: (state) => state.loadPage
    }),

    headersAttributes() {
      return this.headers.filter(header => header.value.startsWith('X-'))
    },

    visibleAttributes(){
      return this.attributeList.filter((attribute, index) => {
        return attribute.value !== '' && index !== this.attributeIndex
      })
    },

    addDisabled() {
      const name = this.attributeObject.name
      const value = this.attributeObject.value
      const isNameInvalid = this.isValidName(name)

      return !name || !value || isNameInvalid !== true
    }
  },

  created() {
    this.parseHeadersTableUsers()
  },

  methods: {
    ...mapActions('programAuthz', ["apiGetAuthzUsers", "apiCreateAuthzUsers", "apiUpdadeAuthzUsers"]),
    isUserEnabled(attributes) {
      // o status vem do Keycloak (campo nativo enabled); sem o dado, não assume "Ativado"
      return attributes.enabled == "true" || attributes.enabled === true
    },
    getUserStatus(attributes){
      return this.isUserEnabled(attributes) ? "Ativado" : "Desativado"
    },

    parseHeadersTableUsers() {
      const headersAttributesKeys = []
      this.headers = []

      this.authzUserList.forEach(user => {
        Object.keys(user.attributes).forEach(key => {
          if(key.startsWith('X-') && !headersAttributesKeys.includes(key) && user.attributes[key] !== "") {
            headersAttributesKeys.push(key)
          }
        })
      })

      const headersAttributes = headersAttributesKeys.map(key => ({
        text: key.replace('X-', '').replace(/-/g, ' '),
        value: key
      }))

      const actionColumn = { text: "", value: "actions", sortable: false }

      this.headers.push(...this.headersDefault, ...headersAttributes, actionColumn)
    },

    translateUserGroup(group) {
      let groupList = {
        "consultant": "Consultante",
        "master": "Master",
        undefined: "Master",
        "operator": "Operador",
      }
      return groupList[group]
    },
    updateModalActive(value) {
      this.isModalActive = value
    },

    editAttribute(index) {
      const attribute = this.attributeList[index]

      this.attributeObject = {
        name: attribute.name,
        value: attribute.value
      }

      this.isEditingAttribute = true
      this.attributeIndex = index
    },

    cancelEditAttribute() {
      this.attributeObject = {
        name: "",
        value: ""
      }
      this.isEditingAttribute = false
      this.attributeIndex = null
    },

    addAttribute(attribute) {
      const newAttribute = {
        name: attribute.name,
        value: attribute.value
      }

      if (this.isEditingAttribute) {
        this.attributeList.splice(this.attributeIndex, 1, newAttribute)
        this.isEditingAttribute = false
        this.attributeIndex = null
      } else {
        this.attributeList.push(newAttribute)
      }

      this.attributeObject = {
        name: "",
        value: ""
      }
    },

    removeAttribute(index) {
      this.attributeIndex = index
      const attribute = this.attributeList[index]

      const removeAttribute = {
        name: attribute.name,
        value: ""
      }
      this.attributeList.splice(this.attributeIndex, 1, removeAttribute)
      this.attributeIndex = null
    },

    cancelUserForm(){
      this.isModalActive = false
      this.isEditingUser = false
      this.$nextTick(() => {
        Object.assign(this.user, {
          name: "",
          last_name: "",
          email: "",
          attributes: {
            group: "",
            enabled: true
          }
        })
        this.cancelEditAttribute()
        this.attributeList = []
      })
    },
    editUser(selectedUser){
      this.isEditingUser = true

      this.$set(selectedUser.attributes, 'enabled', this.isUserEnabled(selectedUser.attributes))

      for (const key in selectedUser.attributes) {
        if (key.startsWith('X-')) {
          this.attributeList.push({
            name: key.replace('X-', '').replace(/-/g, ' '),
            value: selectedUser.attributes[key]
          })
        }
      }

       Object.assign(this.user, {
          name: selectedUser.name,
          last_name: selectedUser.last_name,
          email: selectedUser.email,
          attributes: {
            group: selectedUser.attributes.group,
            enabled: selectedUser.attributes.enabled
          }
       })
      this.isModalActive = true
    },
    async submitUserForm() {
      let feedbackContext = this.isEditingUser ? ['editado', 'editar'] : ['cadastrado','cadastrar']
      this.user.attributes.enabled = this.user.attributes.enabled ? "true" : "false"

      const formattedAttributes = {}
      this.attributeList.forEach(attribute => {
        const attributeName = `X-${attribute.name}`.replace(' ', '-')
        formattedAttributes[attributeName] = attribute.value
      })

      Object.assign(this.user.attributes, {
        ...this.user.attributes,
        ...formattedAttributes
      })
      try {
        if(this.isEditingUser){
          await this.apiUpdadeAuthzUsers(this.user)
        } else {
          await this.apiCreateAuthzUsers(this.user)
        }

        this.cancelUserForm()
        await this.apiGetAuthzUsers()
        this.parseHeadersTableUsers()

        this.showFeedback({
          color: "success",
          message: `O usuário foi ${feedbackContext[0]} com sucesso na organização!`,
        })
      } catch(error) {
        loader.stopProgressLoadPage()
        this.showFeedback({
          color: "error",
          message: error.response.data.message || `Erro ao ${feedbackContext[1]} usuário!`,
        })
      }
    },
    isValidName(value) {
      let attribute = this.attributeList.findIndex(attr => attr.name.replace('X-', '') === value && attr.value !== '') > -1 ? false : true

      if(!attribute && !this.isEditingAttribute) {
        return 'Já existe essa informação na lista.'
      }

      return !value || (!String(value).match(/[^a-zA-Z0-9 ]/g) && !String(value).match(/ {2,}/)) || 'Use apenas letras, números e espaços simples.'
    },
  }
}
</script>

<style>
</style>
